import HttpHelpers from './helpers';

const BookingApiEndpoints = {
  createBooking: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('booking', data)
      .then((response) => response.data);
  },

  updateBooking: (bookingId, data) => {
    return HttpHelpers.authenticatedAxios
      .patch(`booking/${bookingId}`, data)
      .then((response) => response.data);
  },

  submitBooking: (bookingId) => {
    return HttpHelpers.authenticatedAxios
      .post(`booking/${bookingId}/submit`)
      .then((response) => response.data);
  },

  getBooking: (bookingId) => {
    return HttpHelpers.authenticatedAxios
      .get(`booking/${bookingId}`)
      .then((response) => response.data);
  },

  cancelBooking: (bookingId, data) => {
    return HttpHelpers.authenticatedAxios
      .delete(`booking/${bookingId}`, { data })
      .then((response) => response.data);
  },
};

export default BookingApiEndpoints;
